import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PolicyIcon from "@mui/icons-material/Policy";
import DescriptionIcon from "@mui/icons-material/Description";
import LockIcon from "@mui/icons-material/Lock";

const Settings = () => {
  const navigate = useNavigate();
  const isFirstLogin = useSelector((state) => state.auth.isFirstLogin);

  const settingsOptions = [
    {
      title: "Privacy Policy",
      icon: <PolicyIcon sx={{ fontSize: 60, color: "#C02026" }} />,
      route: "https://posrednik24.com/en/privacy-policy/",
      isExternal: true,
    },
    {
      title: "Terms & Conditions",
      icon: <DescriptionIcon sx={{ fontSize: 60, color: "#C02026" }} />,
      route: "https://posrednik24.com/en/terms-and-conditions/",
      isExternal: true,
    },
    {
      title: isFirstLogin ? "Set Password" : "Change Password",
      icon: <LockIcon sx={{ fontSize: 60, color: "#C02026" }} />,
      route: "/change-password",
      isExternal: false,
    },
  ];

  const handleCardClick = (option) => {
    if (option.isExternal) {
      window.open(option.route, "_blank");
    } else {
      navigate(option.route);
    }
  };

  return (
    <Box sx={{ padding: "20px" }}>
      <Grid container spacing={3}>
        {settingsOptions.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.title}>
            <Card
              sx={{
                borderRadius: "8px",
                padding: "20px",
                textAlign: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0px 0px 40px -20px rgba(0,0,0,0.4)",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0px 10px 40px -10px rgba(0,0,0,0.5)",
                },
              }}
              onClick={() => handleCardClick(option)}
            >
              <CardContent>
                <Box sx={{ marginBottom: "15px" }}>
                  {option.icon}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {option.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Settings;

